import styled from 'styled-components';

import { Box } from '@sternum/styled-system';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const Card = styled(Box)`
  border-radius: ${(props) => (props.borderRadius as string) || '4px'};
  border: 1px solid ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
  background: ${ct({ Dark: Colors.White, Light: Colors.White })};
  padding: ${(props) => props.padding || props.p || '16px'};
`;
